import { getSiteProps } from "@/utils/siteProps";

export const getJdUrl = (
  jobData: jobDescriptionType | jobDataType,
  domain: string,
  searchParams?: { [key: string]: string | undefined },
) => {
  const setCookie = (
    name: string,
    value: string,
    days: number,
    domain: string,
  ) => {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie =
      name + "=" + (value || "") + ";domain=" + domain + expires + "; path=/";
  };

  const setSplCookie = (val: string) => {
    if (val) {
      const domain = window.location.host.split(".").slice(-2).join(".");
      setCookie("SPL", val, 1, domain);
    }
  };

  const iscjt = jobData?.isCJT;
  const isJobType = jobData?.jobTypes
    ? jobData?.jobTypes.includes("SJS")
    : false;

  const spl = searchParams?.spl || "";
  let splParam = spl ? "?spl=" + spl : "";

  if (isJobType) {
    if (!spl) {
      splParam = "?spl=MSJ_OnSite";
    }

    setSplCookie(spl);
    return `https://${domain}${jobData.jdUrl}${splParam}`;
  }

  if (iscjt) {
    setSplCookie(spl);
    // return `https://www.foundit.in/seeker/cjt/job-vacancy-${url}-${jobData?.kiwiJobId}${splParam}`;
    return `https://${domain}${jobData.jdUrl}${splParam}`;
  } else if ("seoJdUrl" in jobData && jobData.seoJdUrl) {
    const jdUrl = `/${jobData.seoJdUrl.substring(1)}`;
    return jdUrl;
  } else {
    return `https://${domain}${jobData.jdUrl}`;
  }
};

export const getJDUrlWithDomain = (jdUrl: string, url: string) => {
  if (!jdUrl) return "";

  if (jdUrl.startsWith("http://") || jdUrl.startsWith("https://")) {
    return jdUrl;
  }

  const siteProps = getSiteProps(url);

  return `https://${siteProps?.domain}${jdUrl}`;
};
